import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isLoggedIn } from 'action/auth'
import React, { useEffect } from 'react'
import Loader from 'view/component/loader'
import PropTypes from 'prop-types'
import LoggedInRoutes from './logged-in-routes'
import LoggedOutRoutes from './logged-out-routes'

const Routes = ({ isAuthenticated, isLoggedIn, loginCheckComplete }) => {
  useEffect(() => {
    isLoggedIn()
  }, [])

  return datastoreRoutes(loginCheckComplete, isAuthenticated)
}

const datastoreRoutes = (loginCheckComplete, isAuthenticated) => (
  loginCheckComplete && isAuthenticated
    ? <LoggedInRoutes />
    : loginCheckComplete
      ? <LoggedOutRoutes />
      : <Loader />)

Routes.propTypes = {
  isAuthenticated: PropTypes.bool,
  isLoggedIn: PropTypes.func,
  location: PropTypes.object,
  loginCheckComplete: PropTypes.bool
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loginCheckComplete: state.auth.loginCheckComplete
})

const mapDispatchToProps = (dispatch) => ({
  isLoggedIn: bindActionCreators(isLoggedIn, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Routes)
